import React from 'react'
import styled, { css } from 'styled-components'

import { mediaMinTablet } from '../theme'

export type ChipButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  highlighted?: boolean
}

export const ChipButton: React.FC<ChipButtonProps> = ({
  children,
  highlighted = false,
  ...props
}: ChipButtonProps) => {
  return (
    <Root $highlighted={highlighted} {...props}>
      <span>{children}</span>
    </Root>
  )
}

const Root = styled.button<{
  $highlighted: boolean
}>`
  border: none;
  outline: none;
  background: transparent;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 10px;
  font-weight: 700;
  line-height: 12px;
  transition: all 0.2s ease;
  cursor: pointer;

  ${mediaMinTablet(css`
    font-weight: 600;
  `)}

  ${({ $highlighted }) => {
    if ($highlighted) {
      return css`
        color: var(--primary-9);
      `
    }

    return css`
      color: var(--text-7);
    `
  }}
`
